<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";

  div {
    border: 1.5px solid colors.get(interfaceSwGrey_5);
    border-radius: 16px;
    padding: utils.in_rem(6px);
    display: flex;
    flex-direction: column;
  }
</style>

<script>
  import MessageEditor from "./MessageEditor.svelte";
  import SubjectLine from "./SubjectLine.svelte";

  export let messageText;
  export let subject;
  export let attachmentIds;
  export let toolbar;
</script>

<div>
  <SubjectLine bind:value={subject} />
  <MessageEditor bind:value={messageText} bind:attachmentIds {toolbar} />
</div>
